import type { ComboboxOption } from "@rumbledirect/ui-v2";

/**
 * Dutch labels for the dossier types (`DossierType` on the backend), keyed by
 * the discriminator value the API returns in `dossierType`. Shared by the
 * overview's Type column and filter and the reporting charts. An unmapped
 * value is shown as itself by the callers, so a new backend type degrades to
 * its raw key instead of a blank.
 */
export const DOSSIER_TYPE_LABELS: Readonly<Record<string, string>> = {
  "repair_direct.generic": "Schadeherstel",
  "repair_direct.hail": "Hagelschade",
  "repair_direct.camper": "Camperschade",
  "repair_direct.truck": "Truckschade",
  "repair_direct.box_truck": "Bakwagenschade",
  "repair_direct.quote": "Offerte",
  "repair_direct.glass": "Glasschade",
};

/** The Type filter's options, in the order of {@link DOSSIER_TYPE_LABELS}. */
export const DOSSIER_TYPE_OPTIONS: readonly ComboboxOption[] = Object.entries(
  DOSSIER_TYPE_LABELS,
).map(([value, label]) => ({ value, label }));
